export function Introduction() {
  return (
    <>
      <p>
        Data protection is of high importance for us at City Falcon Limited, which operates cityfalcon.ai and cityfalcon.co.uk.
        <br />
        <br />
        This privacy policy has been prepared in line with the EU’s
        {' '}
        <a href="https://gdpr-info.eu/" target="_blank" rel="noopener noreferrer"> General Data Protection Regulation</a>
        {' '}
        (GDPR) which took effect on 25 May 2018. GDPR promotes fairness and transparency for all individuals in respect of their personal data. This privacy policy applies to all data we process, and by using City Falcon Limited, you consent to our collection and use of such data.
        This policy, together with our
        {' '}
        <a href="/terms"> Terms of Service</a>
        {' '}
        explain how we may use the information we collect about you, as well as your rights over any personal information we hold about you. If you would like to get in touch about anything in this policy or about your personal data, then please contact us at contact@cityfalcon.ai.
        <br />
        <br />
        The processing of personal data, such as the name, address, or email address of a data subject shall always be in line with the General Data Protection Regulation (GDPR), and in accordance with the country-specific data protection regulations applicable to City Falcon Limited. By means of this data protection declaration, our enterprise would like to inform the general public of the nature, scope, and purpose of the personal data we collect, use and process. Furthermore, data subjects are informed, by means of this data protection declaration, of the rights to which they are entitled.
        <br />
        <br />
        As the controller, City Falcon Limited has implemented numerous technical and organisational measures to ensure the most complete protection of personal data processed through this website. However, Internet-based data transmissions may in principle have security gaps, so absolute protection may not be guaranteed.
      </p>
      <ul className="privacy-list">
        <li>1. Definitions</li>
        <li>
          2. Data we collect
          <ul>
            <li>2.1 What data do we ask you to provide to us, and why</li>
            <li>2.2 What personal data do we share</li>
            <li>2.3 How do we keep your personal data secure</li>
            <li>2.4 How you can access and manage this data.</li>
          </ul>
        </li>
        <li>3. Cookies and Web Beacons</li>
        <li>4. Subscription to our newsletters</li>
        <li>5. Newsletter-Tracking</li>
        <li>6. Contact possibility via the website</li>
        <li>7. Blog subscription and comments</li>
        <li>8. Routine erasure and blocking of personal data</li>
        <li>9. Rights of the data subject</li>
        <li>10. Legal basis for the processing</li>
        <li>11. The legitimate interests pursued by the controller or by a third party</li>
        <li>12. Period for which the personal data will be stored Changes to our policy</li>
      </ul>
    </>
  );
}

export default Introduction;
